import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { DistanceProperty, StringProperty } from '../properties';
import { BeamSchema } from './BeamSchema';
import { CeilingPlaneSchema } from './CeilingPlaneSchema';
import { CeilingTraySchema } from './CeilingTraySchema';
import { ComponentDesignSchema } from './ComponentDesignSchema';
import { FeaturePatternContainerSchema } from './FeaturePatternContainerSchema';
import { RoofContainerSchema } from './RoofContainerSchema';
import { RoofPlaneSchema } from './RoofPlaneSchema';
import { TrussEnvelopeSchema } from './TrussEnvelopeSchema';
import { WallSchema } from './WallSchema';

const PLATE_ELEVATION_TOOLTIP = "The elevation of this level's top plate";
const WALL_HEIGHT_TOOLTIP = 'By default, walls will start at the plate elevation and extend down this distance';
const FLOOR_HEIGHT_TOOLTIP = 'By default, floors will start at the plate elevation and extend up this distance';

export const LevelSchema = new GenericModelSchema('level', {
  category: ModelCategory.IntermediateModel,
  children: {
    componentDesignInsertions: ComponentDesignSchema,

    roofPlanes: RoofPlaneSchema,
    ceilingPlanes: CeilingPlaneSchema,
    ceilingTrays: CeilingTraySchema,
    roofContainers: RoofContainerSchema,
    featurePatternContainers: FeaturePatternContainerSchema,
    beams: BeamSchema,
    walls: WallSchema,
    trussEnvelopes: TrussEnvelopeSchema,
  },
  properties: {
    name: StringProperty.configure({ required: true }),
    plateElevation: DistanceProperty.configure({ helpButtonTooltip: PLATE_ELEVATION_TOOLTIP }),
    wallHeight: DistanceProperty.configure({ helpButtonTooltip: WALL_HEIGHT_TOOLTIP }),
    floorHeight: DistanceProperty.configure({ helpButtonTooltip: FLOOR_HEIGHT_TOOLTIP, displayName: 'Floor Depth' }),
  },
  preSorted: true,
});
